<template>
  <div class="ping-timer">
    <!-- Component is intentionally empty as it's just for background processing -->
  </div>
</template>

<script>
import { ping } from "../api/parseContent.js";
import { wm } from "../../pkg/regcogniza_front.js";

export default {
  name: "PingTimer",
  data() {
    return {
      timer: null,
    };
  },
  created() {
    // Start the timer when component is created
    this.startTimer();
  },
  beforeDestroy() {
    // Clean up timer when component is destroyed
    this.stopTimer();
  },
  methods: {
    // Generate UUID v4
    generateUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    startTimer() {
      // Clear any existing timer
      this.stopTimer();

      // Set up new timer to run every 10 seconds
      this.timer = setInterval(async () => {
        try {
          const token = localStorage.getItem("token");
          console.log("token:" + token);
          if(token === undefined || token === "" || token === null) {
            return;
          }
          const response = await ping({
            ese: this.generateUUID(),
            token: token,
          });
          console.log(response.code);
          if (response.code === 999) {
            this.$message({
              type: "info",
              duration: 500,
              message: response.msg,
            });
            this.$router.push("/");
            localStorage.removeItem("token");
            return;
          }
          if (response && response.data) {
            // Store the response data in memory
            await wm(response.data);
          }
        } catch (error) {
          console.error("Error in ping timer:", error);
        }
      }, 10000); // 10 seconds
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
};
</script>

<style scoped>
.ping-timer {
  display: none; /* Hide the component as it's just for background processing */
}
</style>
